/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createPortalRpc = {
  serviceName: 'com.hubspot.academy.simulation.environment.rpc.PortalService',
  rpcName: 'createPortal',
  auth: 'app',
  fingerprint: 'NdGGvJ0sPL3632hfrsF295wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const assignSinglePortalRpc = {
  serviceName: 'com.hubspot.academy.simulation.environment.rpc.PortalService',
  rpcName: 'assignSinglePortal',
  auth: 'app',
  fingerprint: 'NdGGvJ0sPL3632hfrsF295wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};